<script lang="ts" setup>
import { useLessonRoomStore } from '../../model/store'
import { useTracksLiveKit } from '../../model/tracks-live-kit.hook'
import { useLessonRoomAnalytics } from '../../model/lesson-room/lesson-room-analytics.hook'
import LessonRoomControlButton from '../lesson-room/LessonRoomControlButton.vue'

defineOptions({
  name: 'LiveKitButtonMic',
})

const lessonRoomStore = useLessonRoomStore()
const { trackClickMic } = useLessonRoomAnalytics()

const {
  isMicEnabled,
  toggleMic,
} = useTracksLiveKit()

const handleClick = (): void => {
  trackClickMic()

  if (lessonRoomStore.isDeniedMic) {
    lessonRoomStore.setPermissionsBlocked(true)
    return
  }

  void toggleMic()
}
</script>

<template>
  <LessonRoomControlButton
    :icon="isMicEnabled ? { name: 'microphone' } : { name: 'microphone-slash' }"
    label="Mic"
    :enabled="isMicEnabled"
    :danger="!isMicEnabled"
    :alert="lessonRoomStore.isDeniedMic"
    @click="handleClick"
  />
</template>
